module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Fleming Rutledge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Fleming Rutledge")]), _vm._v(" is an Episcopal priest, a best-selling author, and a widely recognized preacher whose published sermon collections have received acclaim across denominational lines. Her other books include "), _c('I', [_vm._v("Help My Unbelief, Three Hours: Sermons for Good Friday, Advent: The Once and Future Coming of Jesus Christ")]), _vm._v(", and "), _c('I', [_vm._v("The Crucifixion: Understanding the Death of Jesus Christ")]), _vm._v(", which won "), _c('I', [_vm._v("Christianity Today's")]), _vm._v(" 2017 Book of the Year Award.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qMOEM8/images/cover.jpg?1684515369838",
      "alt": "This image is the cover for the book Advent"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Advent\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Advent, says Fleming Rutledge, is not for the faint of heart. As the midnight of the Christian year, the season of Advent is rife with dark, gritty realities. In this book, with her trademark wit and wisdom, Rutledge explores Advent as a time of rich paradoxes, a season celebrating at once Christ’s incarnation and his second coming, and she masterfully unfolds the ethical and future-oriented significance of Advent for the church.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0